import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { MarketplacePlatformModel } from '../../../../models/dashboard/marketplace/marketplaceModels';


const getMarketplacePlatform = (): Promise<Array<MarketplacePlatformModel>> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplace/get-platforms`)
}
export default getMarketplacePlatform;